import { Agency } from '@app/models';
import { Corridor, corridor, DictionaryEntity, TimetablePeriod, TrainType } from '@app/pcs/models';
import {
  commonTrainParameters,
  TrainParameters,
} from '@dossier/models/train-parameters';
import { gql } from 'apollo-angular';

export interface ParameterSetCode {
  id?: number;
  name?: string;
  usedInCatalogDossiers?: string;
  imAgency?: Agency;
  corridor?: Corridor;
  processType?: DictionaryEntity;
  trainType?: TrainType;
  trainParameters?: TrainParameters;
  ttp?: TimetablePeriod;
}

export const parameterSetCodeTemplate = gql`
  fragment parameterSetCodeTemplate on ParameterSetCodeTemplate {
    id
    name
    imAgency {
      id
      name
    }
    corridor {
      ...corridor
    }
    trainType {
      id
      description
    }
    ttp {
      id
    }
  }
  ${corridor}
`;

export const parameterSetCodeTemplateDetailed = gql`
  fragment parameterSetCodeTemplateDetailed on ParameterSetCodeTemplate {
    ...parameterSetCodeTemplate
    usedInCatalogDossiers
    processType {
      id
      description
    }
  }
  ${parameterSetCodeTemplate}
`;

export const parameterSetCodeTemplateDetailedWithTrainParameters = gql`
  fragment parameterSetCodeTemplateDetailedWithTrainParameters on ParameterSetCodeTemplate {
    ...parameterSetCodeTemplateDetailed
    trainParameters {
      ...commonTrainParameters
    }
  }
  ${parameterSetCodeTemplateDetailed}
  ${commonTrainParameters}
`;
